import React from 'react'

export default function Layout({ account, wide = false, children }) {
  return (
    <div className="min-h-screen bg-sky-900">
      <main className={`${wide ? 'max-w-5xl' : 'max-w-2xl'} mx-auto py-8`} aria-label={account?.name ? `${account.name} booking` : 'Venue booking'}>
        {children}
      </main>
    </div>
  )
}
